<template>
  <q-modal
    v-model="modalOpened"
    :content-classes="computedContentClasses"
    :content-css="contentCss"
    @show="handleShow"
    @hide="$emit('hide')"
    @escape-key="$emit('escape-key')"
  >
    <div class="modal-header">
      <q-toolbar color="white" text-color="grey-9">
        <q-toolbar-title>{{ title }}</q-toolbar-title>

        <q-btn @click="modalOpened = false" flat dense>
          <q-icon name="close" color="grey-5"/>
        </q-btn>
      </q-toolbar>

      <slot name="header"></slot>
    </div>

    <div class="modal-body big-modal-scroll col scroll" :class="bodyClasses">
      <slot name="content"></slot>
    </div>

    <div v-if="successHandler || $slots.footer" class="modal-footer">
      <slot name="footer">
        <q-btn @click="successHandler" color="positive">
          {{ actionLabel ? actionLabel : $t('save') }}
        </q-btn>
      </slot>
    </div>
  </q-modal>
</template>

<script>
  export default {
    data () {
      return {
        modalOpened: false
      }
    },
    props: {
      actionLabel: {
        type: String,
        required: false,
        default: null
      },
      contentClasses: {
        type: [Object, Array, String],
        required: false,
        default: () => []
      },
      contentCss: {
        type: [Object, Array, String],
        required: false,
        default: () => ''
      },
      bodyClasses: {
        type: [Object, Array, String],
        required: false,
        default: () => []
      },
      width: {
        type: String,
        default: null
      },
      scroll: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        required: true
      },
      value: {
        type: Boolean,
        required: true
      },
      successHandler: {
        type: Function,
        required: false,
        default: null
      },
      title: {
        type: String,
        required: false,
        default: ''
      },
      autofocus: {
        type: Object
      }
    },

    computed: {
      computedContentClasses () {
        switch (typeof this.contentClasses) {
        case 'string':
          return this.defaultClasses.concat([this.contentClasses])
        case 'object':
          const classes = Array.isArray(this.contentClasses) ? this.contentClasses : [this.contentClasses]

          return this.defaultClasses.concat(classes)
        default:
          return this.defaultClasses
        }
      },
      widthClass () {
        return this.width ? 'width-' + this.width : null
      },
      defaultClasses () {
        return [
          this.name,
          'default-modal',
          'column',
          'no-wrap',
          { [this.widthClass]: this.width }
        ]
      }
    },

    methods: {
      handleShow () {
        if (this.autofocus) {
          this.autofocus.focus()
        }

        this.$emit('show')
      }
    },

    watch: {
      value (val) {
        this.modalOpened = val
      },
      modalOpened (val) {
        this.$emit('input', val)
      }
    }
  }
</script>
